const INFO = {
	main: {
		title: "Donald Flynn",
		name: "Donald Flynn",
		email: "donaldflynn@hotmail.co.uk",
		logo: "../logo.jpg",
	},

	socials: {
		github: "https://github.com/donaldflynn",
		linkedin: "https://www.linkedin.com/in/donny-flynn-7821b4216",
		instagram: "https://www.instagram.com/donaldgmflynn/",
	},

	homepage: {
		title: "Hello",
		description:
			"This is my website",
	},

	about: {
		title: "I'm Donald Flynn",
		description:
			"This is a section about me",
	},

	projects: [
		{
			title: "Project 1",
			description:
				"This is a project I might add",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com",
		},

	],
};

export default INFO;
